import createIcon from '../../createIcon';

/**
 * @component @name AlignVerticalTop
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjIgMlY0SDJWMkgyMlpNNyAyMkgxMFY2SDdWMjJaTTE0IDE2SDE3VjZIMTRWMTZaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const AlignVerticalTop = createIcon('AlignVerticalTop', [
  ['path', { d: 'M22 2V4H2V2H22ZM7 22H10V6H7V22ZM14 16H17V6H14V16Z', key: 'g9zpf6' }],
]);

export default AlignVerticalTop;
